import React, { useContext } from "react";
import Can from "../can/Can";
import { walletDetails } from "../../rbac-consts";
import { AppContext } from "../../App";

import { default as AdminWalletDetailsContainer } from "./admin/WalletDetailsContainer";
import { default as ClientWalletDetailsContainer } from "./client/WalletDetailsContainer";

const WalletDetailsWrapper = ({ match }) => {
  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={walletDetails.ADMIN}
        yes={() => (
          <AdminWalletDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={walletDetails.USER}
        yes={() => (
          <ClientWalletDetailsContainer match={match} />
        )}
      />
    </>
  );
};

export default WalletDetailsWrapper;